import dayjs, { Dayjs } from 'dayjs'
import { RangeValueType } from 'rc-picker/lib/PickerInput/RangePicker'
// import { findThisAndLastWeek } from './dateRangeSelector'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

export const startDateRelativeFromToday = -29

export const predefinedRanges = [
  'Today',
  'This week',
  'Last week',
  'This month',
  'Last 30 days',
  'Last month',
  'This year',
  'This FY',
  'Last FY',
]

export const findThisAndLastWeek = (): {[key: string]: RangeValueType<Dayjs>} => {
  const currentDate = new Date()
  const getCurrentDay = currentDate.getDay()
  let lastAndThisWeek: {[key: string]: RangeValueType<Dayjs>} = {
    this_week: [dayjs().startOf('week').add(1, 'd'), dayjs().endOf('day')],
    last_week: [dayjs().startOf('week').subtract(1, 'week').add(1, 'd'), dayjs().startOf('week').endOf('day')],
  }

  if (getCurrentDay === 0) {
    lastAndThisWeek = {
      this_week: [dayjs().startOf('week').subtract(1, 'w').add(1, 'd'), dayjs().endOf('day')],
      last_week: [dayjs().startOf('week').subtract(2, 'w').add(1, 'd'), dayjs().startOf('week').subtract(1, 'w').endOf('day')],
    }
  }
  return lastAndThisWeek
}

export const restrictStartDate = (start: dayjs.Dayjs, end: dayjs.Dayjs, campaignStart) => {
  if (campaignStart && start.isBefore(campaignStart)) {
    return [campaignStart, end] as [Dayjs, Dayjs]
  }
  return [start, end] as [Dayjs, Dayjs]
}

export const checkDefaultDateTime = (defaultDate: string, campaignCreationDate: string, campaignStartDate?: string): [Date, Date] => {
  const minAllowedDate = campaignStartDate ? dayjs(campaignStartDate) : dayjs(campaignCreationDate)
  let tempDateObj: RangeValueType<Dayjs> = [dayjs().startOf('day'), dayjs().endOf('day')]
  const { this_week, last_week } = findThisAndLastWeek()
  const index = predefinedRanges.indexOf(defaultDate)
  if (index === 0) {
    tempDateObj = [dayjs().startOf('day'), dayjs().endOf('day')]
  } else if (index === 1) {
    tempDateObj = restrictStartDate(this_week[0] as Dayjs, this_week[1] as Dayjs, minAllowedDate) // findThisAndLastWeek().this_week
  } else if (index === 2) {
    tempDateObj = restrictStartDate(last_week[0] as Dayjs, last_week[1] as Dayjs, minAllowedDate) // findThisAndLastWeek().last_week
  } else if (index === 3) {
    tempDateObj = restrictStartDate(dayjs().startOf('month'), dayjs().endOf('day'), minAllowedDate) // [dayjs().startOf('month'), dayjs().endOf('day')]
  } else if (index === 4) {
    tempDateObj = restrictStartDate(dayjs().startOf('day').add(-30, 'd'), dayjs().endOf('day'), minAllowedDate) // [dayjs().startOf('day').add(-30, 'd'), dayjs().endOf('day')]
  } else if (index === 5) {
    tempDateObj = restrictStartDate(dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month'), minAllowedDate) // [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]
  } else if (index === 6) {
    tempDateObj = restrictStartDate(dayjs().startOf('year'), dayjs().endOf('day'), minAllowedDate) // [dayjs().startOf('year'), dayjs().endOf('day')]
  } else if (index === 7) {
    tempDateObj = restrictStartDate(dayjs().month(3).startOf('month').subtract(dayjs().month() < 3 ? 1 : 0, 'year'), dayjs().endOf('day'), minAllowedDate)
    // tempDateObj = [
    //   dayjs().month(3).startOf('month').subtract(dayjs().month() < 3 ? 1 : 0, 'year'),
    //   dayjs().endOf('day'),
    // ]
  } else if (index === 8) {
    tempDateObj = restrictStartDate(dayjs().month(3).startOf('month').subtract(dayjs().month() < 3 ? 2 : 1, 'year'), dayjs().month(2).endOf('month').subtract(dayjs().month() < 3 ? 1 : 0, 'year'), minAllowedDate)
    // tempDateObj = [
    //   dayjs().month(3).startOf('month').subtract(dayjs().month() < 3 ? 2 : 1, 'year'),
    //   dayjs().month(2).endOf('month').subtract(dayjs().month() < 3 ? 1 : 0, 'year'),
    // ]
  }
  const startDate = new Date((tempDateObj[0] ?? dayjs()).format('YYYY-MM-DD'))
  const endDate = new Date((tempDateObj[1] ?? dayjs()).format('YYYY-MM-DD'))

  return [startDate, endDate]
}

export const displayFilterValue = (value: string[]): string => {
  if (value.length > 1) {
    return `(${value.length}) values`
  }
  if (!value[0]) {
    return ''
  }
  return value[0].length <= 8 ? value[0] : `${value[0].slice(0, 8)}...`
}

export const isCampaignInRange = (
  endDate: dayjs.ConfigType,
  campaignDate: dayjs.ConfigType | null,
): boolean => {
  if (!campaignDate) return true
  const end = dayjs(endDate)
  const campaign = dayjs(campaignDate)

  return campaign.isSameOrBefore(end)
}
